import { FC, useContext } from "react";
import { Modal } from "react-bootstrap";
import { QuestionnaireContext } from '../QuestionnaireContext';

const AnswerSubmittingModal: FC<{}> = () => {

    const {
        setAnswerSubmittingModal,
        answerSubmittingModal
    } = useContext(QuestionnaireContext)

    return (
        <Modal
            centered
            show={answerSubmittingModal}
            size="lg"
            contentClassName="finish-modal"
        >
            <div>
                <div className="modal__header">
                    <h6 className="modal__header-title">
                        Submitting Answers
                    </h6>
                </div>
                <div className="modal__body d-flex align-items-center">
                    <p className="mb-2">
                        Your answers are being submitted. Please Wait
                    </p>
                    <div className="dot-flashing"></div>
                </div>
                <div className="modal__footer">
                    <button
                        onClick={() => setAnswerSubmittingModal(false)}
                        className="btn cancel-btn mx-3"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default AnswerSubmittingModal;